import React, { useRef } from 'react';
import PanelIcon from './PanelIcon';

const Bundle = ({ bundle = {}, onSelect, selections }) => {
	const { id, title, itemCount, panels } = bundle;

	const selected = selections?.some((panel) => panel?.id === id);
	const disabled = !onSelect;

	const radioRef = useRef(null);

	const handleSelect = (e) => {
		onSelect(id);
	};

	/** Deselects radio button on space key press */
	const handleKeyDown = (e) => {
		/**
		 * Skip this method if the input is not already selected. The default onClick will take 
		 * care of selecting the input.
		 * 
		 * Why?
		 * If setting the input to selected, we would need to call e.preventDefault() because the 
		 * default behavior would immediately deselect the input again. However, if we were to 
		 * select this input, while calling preventDefault, the browser won't update the input to 
		 * 'checked'.
		 * I do not know why this problem happens here but not in PanelList.
		 */
		if (!selected) {
			return;
		}
		// Space = toggle
		if (e.key === ' ') {
			e.preventDefault();
			onSelect(id);
		}
	};
	return (
		<div
			className={`alcat-bundle card flex-grow-1 position-relative ${selected ? 'selected' : ''}`}
			style={{ cursor: 'pointer' }}
		>
			<div className="card-body p-2">
				<div>
					<input
						ref={radioRef}
						type="radio"
						className="form-check-input position-absolute opacity-0"
						id={`alcat-bundle-${id}`}
						name="ALCATPanels"
						checked={selected}
						readOnly
						onClick={handleSelect}
						onKeyDown={handleKeyDown}
						disabled={disabled}
					/>
					<div className="ms-1">
						<label
							className="form-check-label stretched-link text-center flex-grow-1 m-0 cursor-pointer lh-1"
							htmlFor={`alcat-bundle-${id}`}
							style={{
								color: 'revert',
								fontSize: '1.15em'
							}}
						>
							{title}
						</label>
						{!!itemCount && <p className="m-0">{itemCount} items</p>}
					</div>
				</div>
				<hr className="opacity-100" />
				{panels.map((panel, index) => (
					<Panel key={index} {...panel} />
				))}
			</div>
		</div>
	);
};

export const Panel = ({ element, iconColor, itemCount, description, alignItems = 'start' }) => {
	if (element) {
		return element;
	}

	const labelStyle = { minWidth: 'fit-content', flexShrink: 0, flexBasis: '5ch' };

	return (
		<div className={`d-flex align-items-${alignItems} gap-2 mb-1`}>
			<span style={labelStyle}>
				<PanelIcon color={iconColor} />
				{!!itemCount && <span className="ms-2">{itemCount}</span>}
			</span>
			<span className="flex-grow-1">{description}</span>
		</div>
	);
};

export default Bundle;
